import { render, staticRenderFns } from "./about-swiper-3c.vue?vue&type=template&id=76174040"
import script from "./about-swiper-3c.vue?vue&type=script&lang=js"
export * from "./about-swiper-3c.vue?vue&type=script&lang=js"
import style0 from "./about-swiper-3c.vue?vue&type=style&index=0&id=76174040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports